
<div class="row modal-bar">
  <div class="col-sm-10">
    <h5 class="modal-title">{{ passedData.title }}</h5>
  </div>
  <div class="col-sm-2">
    <div class="modal-actions">
      <div class="modal-close">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
      </div>
    </div>
  </div>
</div>



<form [formGroup]="form" class="form-content">

  <div class="section-wrapper">
    <div class="form-layout">

      <div class="row">

        <div class="col-lg-6">
          <div class="form-group">
            <label class="form-control-label">{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.LABEL.TYPE' | translate}} <span class="tx-danger">*</span></label>
            <ng-select (change)="onTypeChange($event)" [items]="constants.venueBuildingBlockTypes" bindLabel="Name" bindValue="Id" placeholder="{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.PLACEHOLDER.TYPE' | translate}}" formControlName="VenueBuildingBlockTypeId"
            [clearable]="false" notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" appendTo="body" ></ng-select>
            <t4-display-validation controlName="VenueBuildingBlockTypeId" [form]="form" [messages]="validationMessages"></t4-display-validation>
          </div>
        </div>



        <div class="col-lg-6" >
          @if (form.controls['VenueBuildingBlockTypeId'].value == 1) {
            <div class="form-group" >
              <label class="form-control-label">{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.LABEL.VERSION' | translate}} <span class="tx-danger">*</span></label>
              <input class="form-control"  name="Version" formControlName="Version" placeholder="{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.PLACEHOLDER.VERSION' | translate}}" [disabled]="editingEventPlacement || hasPlacements">
            </div>
          }

          @if (form.controls['VenueBuildingBlockTypeId'].value != 1) {
            <div class="form-group">
              <label class="form-control-label">{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.LABEL.UPPER-SECTION' | translate}} <span class="tx-danger">*</span></label>
              <input class="form-control" [matAutocomplete]="auto" formControlName="Parent">
              <t4-display-validation controlName="Parent" [form]="form" [messages]="validationMessages"></t4-display-validation>
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="getSelectedVenueDisplayText">
                @for (pi of filteredParentVenues; track pi) {
                  <mat-option [value]="pi">
                    {{ getVBBName(pi) }}
                  </mat-option>
                }
              </mat-autocomplete>
            </div>
          }

        </div>

      </div>


      <div class="row">

        <div class="col-lg-6" >
          <div class="form-group">
            <label class="form-control-label">{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.LABEL.NAME' | translate}} <span class="tx-danger">*</span></label>
            <input class="form-control"  name="Name" formControlName="Name" placeholder="{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.PLACEHOLDER.NAME' | translate}}">
            @if (form.controls['Name'].hasError('required') && form.controls['Name'].touched) {
              <small class="form-error-msg">{{'GENERIC.VALIDATION.REQUIRED' | translate}}</small>
            }
          </div>
        </div>

        <div class="col-lg-6">

          <div class="form-group">
            <label class="form-control-label">{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.LABEL.SHORTEN-NAME' | translate}} <span class="tx-danger">*</span></label>
            <input class="form-control"  name="ShortName" formControlName="ShortName" placeholder="{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.PLACEHOLDER.SHORTEN-NAME' | translate}}">
            @if (editingEventPlacement && form.get('ShortName')?.dirty) {
              <small style="color: #4D4D4D;">{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.WARNING.SHORTEN-NAME' | translate}}</small>
            }
          </div>

        </div>

      </div>


      <div class="row">
        <div class="col-lg-6" >
          <div class="form-group">
            <label class="form-control-label">{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.LABEL.TRIBUNE-NUMBER' | translate}} <span class="tx-danger">*</span></label>
            <input class="form-control"  name="SectionNr" formControlName="SectionNr" placeholder="{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.PLACEHOLDER.TRIBUNE-NUMBER' | translate}}">
            @if (form.controls['SectionNr'].hasError('required') && form.controls['SectionNr'].touched  ) {
              <small class="form-error-msg">{{'GENERIC.VALIDATION.REQUIRED' | translate}}</small>
            }
            @if (form.controls['SectionNr'].hasError('pattern') && form.controls['SectionNr'].touched  ) {
              <small class="form-error-msg">{{'GENERIC.VALIDATION.ONLY-NUMBERS' | translate}}</small>
            }
          </div>
        </div>


        <div class="col-lg-6" >
          <div class="form-group">
            <label class="form-control-label">{{'LOCATION.SECTION.TICKETNAMINGTYPE' | translate}}</label> <span class="tx-danger">*</span>
            <ng-select  [items]="ticketNamingType" bindLabel="Name" bindValue="TicketNamingType" formControlName="TicketNamingType" placeholder="{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.PLACEHOLDER.TRIBUNE-ENTRENCE-TYPE' | translate}}"
            [clearable]="false" notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" appendTo="body"></ng-select>
            <t4-display-validation controlName="TicketNamingType" [form]="form" [messages]="validationMessages"></t4-display-validation></div>
          </div>
        </div>
        @if (!editingEventPlacement) {
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group">
                <label class="form-control-label">{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.LABEL.TRIBUNE-COLOR' | translate}} </label>
                <div>
                  <div fxFlex="30px"><div class="color-picker-display" [(colorPicker)]="color" [style.background]="color" [cpAlphaChannel]="'disabled'" [cpOutputFormat]="'hex'">&nbsp;</div></div>
                  <div class="pt-1" fxFlex>{{ color }}</div>
                </div>
              </div>
            </div>
          </div>
        }
        @if (form.controls['VenueBuildingBlockTypeId'].value == 1) {
          <div class="row">
            <div class="col-lg-10" >
              <div class="form-group"  >
                <label class="form-control-label">{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.LABEL.VENUE' | translate}} <span class="tx-danger">*</span></label>
                <ng-select [items]="stadiumPlanSections" bindLabel="Name" bindValue="Id"
                  placeholder="Type" formControlName="StadiumPlanSectionId"
                [clearable]="false" notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" appendTo="body"></ng-select>
                <t4-display-validation controlName="StadiumPlanSectionId" [form]="form" [messages]="validationMessages"></t4-display-validation>
              </div>
            </div>
            <div class="col-lg-2" style="margin-top: 29px;">
              <div class="form-group">
                <button (click)="openVenueSvgInputDialog('StadiumPlanSectionId')" class="btn btn-block btn-primary bd-0">+</button>
              </div>
            </div>
          </div>
        }


        <div class="row">


          <div class="col-lg-6" >
            <div class="form-group">
              <label class="form-control-label">{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.LABEL.SALES-CATEGORY' | translate}} <span class="tx-danger">*</span></label>
              <ng-select [items]="selectableSaleCategories" bindLabel="Name" bindValue="Id" placeholder="{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.PLACEHOLDER.SALES-CATEGORY' | translate}}" formControlName="SaleCategoryId"
              [clearable]="false" notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" appendTo="body"></ng-select>
              @if (form.controls['SaleCategoryId'].hasError('SaleCategoryId') && form.controls['SaleCategoryId'].touched) {
                <small class="form-error-msg">{{'GENERIC.VALIDATION.REQUIRED' | translate}}</small>
              }
            </div>
          </div>


          <div class="col-lg-6">
            <div class="form-group">
              <label class="form-control-label">{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.LABEL.PRICE-CATEGORY' | translate}} <span class="tx-danger">*</span></label>
              <ng-select [items]="selectablePriceCategories" bindLabel="Name" bindValue="Id" placeholder="{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.PLACEHOLDER.PRICE-CATEGORY' | translate}}" formControlName="PriceCategoryId"
              [clearable]="false" notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" appendTo="body"></ng-select>
              @if (form.controls['PriceCategoryId'].hasError('PriceCategoryId') && form.controls['PriceCategoryId'].touched) {
                <small class="form-error-msg">{{'GENERIC.VALIDATION.REQUIRED' | translate}}</small>
              }
            </div>
          </div>

          @if (form.controls['VenueBuildingBlockTypeId'].value == 1) {
            <div class="col-lg-10">
              <div class="form-group">
                <label class="form-control-label">{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.LABEL.SOFTCARD-IMAGE' | translate}}</label>
                <ng-select [items]="images" bindLabel="Description" bindValue="Id" formControlName="ImageId" placeholder="{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.PLACEHOLDER.SOFTCARD-IMAGE' | translate}}"
                  [clearable]="false" notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" appendTo="body">
                  <ng-template ng-label-tmp ng-option-tmp let-item="item">
                    <div style="display: flex; align-items: center">
                      <div style="width:32px; height:32px; margin-right: 16px;">
                        <img [src]="fileHelper.getResizedImageUrl(item.Url, 32, 32)" style="margin: 0 auto; display: block;"/>
                      </div>
                      <span>{{ item.Description }}</span>
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          }

          @if (form.controls['VenueBuildingBlockTypeId'].value == 1) {
            <div class="col-lg-2" style="margin-top: 29px;">
              <div class="form-group">
                <button (click)="openFileInputDialog('ImageId', ImageTypeEnum.Default)" class="btn btn-block btn-primary bd-0">+</button>
              </div>
            </div>
          }
        </div>

        <div class="row">
          <div class="col-lg-12" >
            <div class="form-group">
              <label class="form-control-label">{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.LABEL.PANORAMA-URL' | translate}}</label>
              <input class="form-control"  name="PanoramaUrl" formControlName="PanoramaUrl" placeholder="{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.LABEL.PANORAMA-URL' | translate}}">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-10">
            <div class="form-group">
              <label class="form-control-label">{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.LABEL.PANORAMA-THUMB' | translate}}</label>
              <ng-select [items]="panoramaImages" bindLabel="Description" bindValue="Id" formControlName="PanoramaImageId" placeholder="{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.LABEL.PANORAMA-THUMB' | translate}}"
                [clearable]="false" notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" appendTo="body">
                <ng-template ng-label-tmp ng-option-tmp let-item="item">
                  <div style="display: flex; align-items: center">
                    <div style="width:32px; height:32px; margin-right: 16px;">
                      <img [src]="fileHelper.getResizedImageUrl(item.Url, 32, 32)" style="margin: 0 auto; display: block;"/>
                    </div>
                    <span>{{ item.Description }}</span>
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>

          <div class="col-lg-2" style="margin-top: 29px;">
            <div class="form-group">
              <button (click)="openFileInputDialog('PanoramaImageId', ImageTypeEnum.Panorama)" class="btn btn-block btn-primary bd-0">+</button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6" >
            <div class="form-group">
              <label class="form-control-label">{{'LOCATION.LOCATIONS.EDITDIALOG.FORM.LABEL.QUALITY' | translate}}</label>
              <input class="form-control" type="number" name="Quality" formControlName="Quality" placeholder="">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 mb-2" >
            {{ 'LOCATION.LOCATIONS.EDITDIALOG.QUALITY.EXPLANATION' | translate }}
          </div>
        </div>

        <div class="form-layout-footer row">
          <div class="col-6">
            @if (!isInArchiveMode) {
              <button (click)="submit()" [disabled]="form.invalid || saving"  class="btn btn-block btn-primary bd-0"> <i class="far fa-save"></i><span>{{ 'GENERIC.BUTTON.SAVE' | translate }}</span></button>
            }
          </div>
          <div class="col-6">
            <button (click)="dialogRef.close(false);"  class="btn btn-block btn-secondary bd-0"><i class="fas fa-ban"></i><span>{{ 'GENERIC.BUTTON.CANCEL' | translate }}</span></button>
          </div>
        </div><!-- form-layout-footer -->

      </div><!-- form-layout -->

    </div>
  </form>
